<template>
  <v-card shaped outlined>
    <v-card-title v-if="note.title">
      <span :class="classTextColor">{{ note.title }}</span>
      <v-spacer />
      <notes-list-note-actions
        v-if="isOwnNote"
        :note="note"
        @submit:success="$emit('submit:success')"
        @submit:fail="$emit('submit:fail')"
      />
    </v-card-title>

    <v-card-text>
      <v-row align="center">
        <v-col v-if="note.severity !== 'NONE'" class="shrink">
          <note-severity-icon :severity="note.severity" show-tooltip />
        </v-col>
        <v-col class="grow">
          <span class="font-italic">
            {{ note.description }}
          </span>
        </v-col>
        <v-col v-if="!note.title" class="shrink">
          <notes-list-note-actions
            v-if="isOwnNote"
            :note="note"
            @submit:success="$emit('submit:success')"
            @submit:fail="$emit('submit:fail')"
          />
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions class="pr-4">
      <div class="text-caption">
        {{ note.created_by.name }} | {{ note.created_at | dateAndTime }}
        <template v-if="wasEdited">
          <br />

          <v-dialog max-width="900">
            <template #activator="{ on: dialog }">
              <v-tooltip bottom>
                <template #activator="{ on: tooltip }">
                  <div class="font-italic">
                    Zuletzt
                    <span
                      class="primary--text"
                      style="cursor: help"
                      v-on="{ ...dialog, ...tooltip }"
                    >
                      bearbeitet
                    </span>
                    am {{ note.updated_at | dateAndTime }}
                  </div>
                </template>
                <span>{{ $t('fresh-vue-notes.actions.show-changes') }}</span>
              </v-tooltip>
            </template>

            <v-card outlined>
              <audit-view :audits="note.audits">
                <template #old-values="{ values }">
                  <note-details
                    v-if="values && !Array.isArray(values)"
                    :note="values"
                    dense
                  />
                </template>
                <template #new-values="{ values }">
                  <note-details
                    v-if="values && !Array.isArray(values)"
                    :note="values"
                    dense
                  />
                </template>
              </audit-view>
            </v-card>
          </v-dialog>
        </template>
      </div>
      <v-spacer />
      <!-- files -->
      <div class="mr-2">
        <notes-list-note-files :note="note" />
      </div>
      <!-- visibility -->
      <div>
        <notes-list-note-visibility :note="note" />
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

import { AuditView } from '@freshsolutions/fresh-vue-audits'
import NotesListNoteActions from './NotesListNoteActions'
import NotesListNoteFiles from './NotesListNoteFiles'
import NotesListNoteVisibility from './NotesListNoteVisibility'
import NoteSeverityIcon from './NoteSeverityIcon'
import NoteDetails from './NoteDetails'

export default {
  name: 'NotesListNote',

  components: {
    AuditView,
    NotesListNoteActions,
    NotesListNoteFiles,
    NotesListNoteVisibility,
    NoteSeverityIcon,
    NoteDetails
  },

  props: {
    note: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters('auth', ['user']),

    classTextColor() {
      const severity = this.note.severity

      return {
        'info--text': severity === 'INFO',
        'success--text': severity === 'SUCCESS',
        'warning--text': severity === 'WARNING',
        'error--text': severity === 'ERROR'
      }
    },

    isOwnNote() {
      return (this.user?.user_id ?? this.user?.id) == this.note?.created_by?.id
    },

    wasEdited() {
      return (this.note?.audits?.length || 0) > 1 // the first one is "created"
    }
  }
}
</script>
